import { Stack, Typography, styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledDurationUpgradeBanner = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderTop: '1px solid',
  borderColor: theme.palette.grey[900],
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.warning.main,
  marginLeft: theme.spacing(1),
}));

export const StyledUpgradeLink = styled(Link)(({ theme }) => ({
  color: theme.palette.grey[50],
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.15,
  textDecoration: 'none',
  marginLeft: 'auto',
}));
